export const validateTaskName = (task) => {
  const name = task.businessObject.get('name');
  if (!name || name.trim() === '') return false;
  return /^[a-zA-Z0-9]+(_[a-zA-Z0-9]+)*$/.test(name);
};

export const validateTaskNameUniqueness = (tasks) => {
  const nameMap = new Map();
  const duplicates = [];

  tasks.forEach((task) => {
    const name = task.businessObject.get('name');
    if (name) {
      const lowerName = name.toLowerCase();
      if (nameMap.has(lowerName)) {
        duplicates.push({ id: task.id, name });
      } else {
        nameMap.set(lowerName, task.id);
      }
    }
  });

  return duplicates;
};

export const validateFunctionDetails = (task) => {
  const isActionTrigger = task.businessObject.get('node:is_action_trigger') === 'true';
  if (!isActionTrigger) return true;
  const funcDetails = task.businessObject.get('node:function_details');
  try {
    const parsed = funcDetails ? JSON.parse(funcDetails) : null;
    return parsed && parsed.id && parsed.func_name && typeof parsed.input_json === 'object';
  } catch (err) {
    return false;
  }
};

export const validateSingleOutgoingRoute = (element) => {
  if (element.type === 'bpmn:Task') {
    const outgoing = element.businessObject.get('outgoing') || [];
    return outgoing.length === 1;
  }
  // Exclusive gateways are allowed multiple outgoing routes
  return true;
};